async function twoGuysAddWishlistUPC() {
  const products = document.querySelectorAll(".Vtl-WishlistProduct");

  for (const card of products) {
    if (card.querySelector(".two-guys-wishlist-upc")) continue;

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) continue;

    const url = new URL(link.href);
    const productJsonUrl = `${url.pathname}.js`;

    try {
      const res = await fetch(productJsonUrl);
      const product = await res.json();

      const sku = product?.variants?.[0]?.sku;

      if (!sku) continue;

      const upc = document.createElement("div");
      upc.className = "two-guys-wishlist-upc";
      upc.textContent = `UPC: ${sku}`;

     const price = card.querySelector('[class*="Price"]');
if (price) {
  price.insertAdjacentElement("beforebegin", upc);
} else {
  link.insertAdjacentElement("afterend", upc);
}
    } catch (e) {
      console.warn("Cannot load UPC", e);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(twoGuysAddWishlistUPC, 1000);
});

document.addEventListener("shopify:section:load", () => {
  setTimeout(twoGuysAddWishlistUPC, 1000);
});
function twoGuysForceWishlistLeftAlign() {
  const cards = document.querySelectorAll(".Vtl-WishlistProduct");

  cards.forEach((card) => {
    card.style.setProperty("text-align", "left", "important");
    card.style.setProperty("align-items", "stretch", "important");

    const link = card.querySelector(".Vtl-WishlistProduct__Link");
    if (link) {
      link.style.setProperty("display", "flex", "important");
      link.style.setProperty("flex-direction", "column", "important");
      link.style.setProperty("align-items", "stretch", "important");
      link.style.setProperty("text-align", "left", "important");
      link.style.setProperty("width", "100%", "important");
    }

    const title = card.querySelector(".Vtl-WishlistProduct__Title");
    if (title) {
      title.style.setProperty("width", "100%", "important");
      title.style.setProperty("text-align", "left", "important");
      title.style.setProperty("align-self", "stretch", "important");
    }

    const upc = card.querySelector(".two-guys-wishlist-upc");
    if (upc) {
      upc.style.setProperty("width", "100%", "important");
      upc.style.setProperty("text-align", "left", "important");
      upc.style.setProperty("align-self", "stretch", "important");
    }

    const price = card.querySelector(".Vtl-WishlistProduct__PriceSection");
    if (price) {
      price.style.setProperty("width", "100%", "important");
      price.style.setProperty("text-align", "left", "important");
      price.style.setProperty("align-self", "stretch", "important");
      price.style.setProperty("justify-content", "flex-start", "important");
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(twoGuysForceWishlistLeftAlign, 500);
  setTimeout(twoGuysForceWishlistLeftAlign, 1500);
  setTimeout(twoGuysForceWishlistLeftAlign, 3000);
});
function twoGuysStyleWishlistHeader() {
  const title = document.querySelector(".Vtl-WishlistPage__Title");
  const desc = document.querySelector(".Vtl-WishlistPage__Description");

  if (title) {
    title.style.setProperty("font-family", '"2Guys Avant Garde Bold", sans-serif', "important");
    title.style.setProperty("font-size", "36px", "important");
    title.style.setProperty("line-height", "0.95", "important");
    title.style.setProperty("font-weight", "700", "important");
    title.style.setProperty("letter-spacing", "0.08em", "important");
    title.style.setProperty("text-transform", "uppercase", "important");
  }

  if (desc) {
    desc.style.setProperty("font-family", '"2Guys Avant Garde", sans-serif', "important");
    desc.style.setProperty("font-size", "18px", "important");
    desc.style.setProperty("line-height", "1.25", "important");
    desc.style.setProperty("font-weight", "400", "important");
    desc.style.setProperty("letter-spacing", "0.12em", "important");
    desc.style.setProperty("text-transform", "uppercase", "important");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(twoGuysStyleWishlistHeader, 300);
  setTimeout(twoGuysStyleWishlistHeader, 1000);
  setTimeout(twoGuysStyleWishlistHeader, 2500);
});
